/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __extends } from "tslib";
import { PluginStateObject } from '../../../../mol-plugin-state/objects';
var VolumeServerInfo = /** @class */ (function (_super) {
    __extends(VolumeServerInfo, _super);
    function VolumeServerInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VolumeServerInfo;
}(PluginStateObject.Create({ name: 'Volume Streaming', typeClass: 'Object' })));
export { VolumeServerInfo };
export var VolumeServerHeader;
(function (VolumeServerHeader) {
    var ValueType;
    (function (ValueType) {
        ValueType.Float32 = 'float32';
        ValueType.Int8 = 'int8';
    })(ValueType = VolumeServerHeader.ValueType || (VolumeServerHeader.ValueType = {}));
})(VolumeServerHeader || (VolumeServerHeader = {}));
